import React, {useEffect, useState} from "react";
import _ from "lodash";
import {DIMENSION_INPUT_FIELDS} from "../../constants/dimension.constant";
import {addSingleDimension, updateSingleDimension} from "../../services/dimension-data.service";
import {XMarkIcon} from "@heroicons/react/24/solid";
import RenderFields from "../../../common/ui/render-fields";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";
import {handleFieldValueChanges, prepareInputFields} from "../../../common/utils/field-change-util";

const AddEditDimension = ({
                              selectedDimension = {},
                              refreshDimensionList,
                              isAddDimension = false,
                              isEditDimension = false
                          }) => {
    const [showModal, setShowModal] = useState(false);
    const [dimension, setDimension] = useState(selectedDimension);
    const [saveInProgress, setSaveInProgress] = useState(false);
    const [dimensionFieldInputs, setDimensionFieldInputs] = useState(DIMENSION_INPUT_FIELDS);

    useEffect(() => {

        if (showModal) {
            if (isEditDimension) {
                setDimension(selectedDimension);
            } else {
                setDimension({});
            }
        }

    }, [showModal]);

    const handleConfirmAction = async () => {
        setSaveInProgress(true);

        const existingDimension = {...dimension};

        if (isEditDimension) {
            await updateSingleDimension(existingDimension);
        } else {
            await addSingleDimension(existingDimension);
        }

        setSaveInProgress(false);
        refreshDimensionList();
        setShowModal(false);
    }

    const handleDimensionChanges = (event) => {
        let existingDimension = {...dimension};
        existingDimension = handleFieldValueChanges(event, existingDimension);

        /*const {name} = event.target;
        if (name === 'dimensionType') {
            const newFields = prepareInputFields(DIMENSION_INPUT_FIELDS, event.target, existingDimension);
            setDimensionFieldInputs(newFields);
        }*/

        setDimension(existingDimension);
    }

    const handleCloseAction = () => {
        setShowModal(false);
    }

    return (
        <>
            {isAddDimension &&
                <button
                    className="button-green px-2 py-1"
                    onClick={() => setShowModal(true)}>
                    Add Dimension
                </button>
            }

            {isEditDimension &&
                <button
                    className="button-green-outline px-3 py-1"
                    onClick={() => setShowModal(true)}>
                    Edit
                </button>
            }

            {showModal ? (
                <>
                    <div
                        className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-x-0 top-0 z-50 outline-none focus:outline-none">
                        <div className="relative w-1/2 my-6 mx-auto max-w-3xl">
                            {/*content*/}
                            <div
                                className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-gray-100 outline-none focus:outline-none">
                                {/*header*/}
                                <div
                                    className="flex items-start justify-between p-5 border-b border-solid rounded-t">
                                    <h3 className="text-lg font-semibold">
                                        {isAddDimension &&
                                            <>Add Dimension</>
                                        }

                                        {isEditDimension &&
                                            <>Edit Dimension</>
                                        }
                                    </h3>

                                    <div className="">
                                        <button
                                            className="button-gray-outline px-1 py-1"
                                            onClick={handleCloseAction}>
                                            <div className="">
                                                <XMarkIcon className="h-6 w-6"/>
                                            </div>
                                        </button>
                                    </div>
                                </div>
                                {/*body*/}
                                <div className="relative p-5 flex-auto">
                                    <div className="leading-relaxed">
                                        <div className="flex flex-wrap justify-start">
                                            <RenderFields
                                                parentForm={dimension}
                                                handleDetailChanges={handleDimensionChanges}
                                                fieldList={_.groupBy(dimensionFieldInputs, 'group')['dimension']}
                                                enableEdit={true}/>
                                        </div>

                                        <div className="flex flex-wrap justify-start">
                                            <RenderFields
                                                parentForm={dimension}
                                                handleDetailChanges={handleDimensionChanges}
                                                fieldList={_.groupBy(dimensionFieldInputs, 'group')['detail']}
                                                enableEdit={true}
                                                fieldClassName={'w-full'}/>
                                        </div>

                                        <div className="flex flex-wrap justify-start">
                                            <RenderFields
                                                parentForm={dimension}
                                                handleDetailChanges={handleDimensionChanges}
                                                fieldList={_.groupBy(dimensionFieldInputs, 'group')['filter']}
                                                enableEdit={true}
                                                fieldClassName={'w-1/2'}/>
                                        </div>
                                    </div>
                                </div>
                                {/*footer*/}
                                <div
                                    className="flex items-center justify-end p-5 border-t border-solid border-blueGray-200 rounded-b">
                                    <div className="ml-4 -mt-1">
                                        <ShowProgressSpinner dataFetchInProgress={saveInProgress}/>
                                    </div>
                                    <button
                                        className="ml-2 text-gray-500 font-bold border border-gray-500 h-8 rounded px-4 outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                        type="button"
                                        onClick={() => setShowModal(false)}>
                                        Cancel
                                    </button>
                                    <button
                                        className="ml-2 bg-green-500 text-white active:bg-green-600 h-8 px-4 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                        type="button"
                                        onClick={handleConfirmAction}>
                                        Confirm Dimension
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                </>
            ) : null}
        </>
    );
}

export default AddEditDimension
